import store from '@store'
import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/rmr',
  component: () => import('@views/ReturnMaterial/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'rmr.index',
      component: () => import('@/components/ReturnMaterial/ReturnMaterialIndex')
    },
    {
      path: 'form/:id',
      name: 'rmr.form',
      component: () => import('@/components/ReturnMaterial/ReturnMaterialForm'),
      beforeEnter: (to, from, next) => {
        // clear validate store
        store.dispatch('UPDATE_VALIDATE_RMR_ITEM_ERROR', null)
        next()
      },
    },
    {
      path: 'formview/:id',
      name: 'rmr.form.view',
      component: () => import('@/components/ReturnMaterial/ReturnMaterialForm'),
      props: { isView: true },
      beforeEnter: (to, from, next) => {
        // clear validate store
        store.dispatch('UPDATE_VALIDATE_RMR_ITEM_ERROR', null)
        next()
      },
    },
    {
      path: 'excel/external',
      name: 'rmr.excel',
      component: () => import('@/components/ReturnMaterial/RMRExcel')
    }
    // {
    //   path: 'warehouse/search',
    //   name: 'rmr.wh',
    //   component: () => import('@/components/ReturnMaterial/ReturnMaterialWH')
    // },
    // {
    //   path: 'warehouse/form/:id',
    //   name: 'rmr.wh.form',
    //   component: () => import('@/components/ReturnMaterial/ReturnMaterialWHForm'),
    // }
  ]
}
